<template>
    <v-dialog v-model="open" max-width="40%" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"  persistent>
        <v-card outlined>
            <v-card-title>
                <span style="color:#FF4132" class="text-center headline" v-html="titulo"></span>
                <v-spacer></v-spacer>
                <v-btn icon right absolute color="primary" dark @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <div>
                    <p style="text-align:justify" v-html="descripcion"></p>
                </div>
                <div class="text-center">
                    <v-btn rounded color="primary" class="text-center" @click="close">Aceptar</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalInformacionComponent',
        inject: ['close'],
        props: {
            open: {
                type: Boolean,
                default: false
            },
            titulo:{
                type:String,
                default:''
            },
            descripcion:{
                type:String,
                default:''
            }
        }
    }
</script>